// extracted by mini-css-extract-plugin
export default {"videoBtn":"short-video_videoBtn__0aUs8"};